import React, { useState, useEffect, useCallback } from 'react';
import useResponsive from '../utils/useResponsive';
import ObligadoSolidarioBanorte from './ObligadoSolidarioBanorte';
import { creditoExcedeInmueble, MENSAJE_CREDITO_INMUEBLE } from '../utils/creditoVsInmueble';

// Estado Civil, Régimen Conyugal y Tipo de Domicilio ya no se capturan aquí:
// se derivan de lo capturado en el módulo Titular / Coacreditado.
const BANORTE_ESTADO_CIVIL_MAP = {
  'Soltero': 'Soltero',
  'Divorciado': 'Divorciado',
  'Viudo': 'Viudo',
  'Casado': 'Casado',
  'Union Libre': 'Otro',
  'Sociedad de Convivencia': 'Otro',
};
function nombreRegimenBanorte(estadoCivil, regimen) {
  if (estadoCivil !== 'Casado') return null;
  if (regimen === 'Sociedad Conyugal') return 'Casado en Sociedad Conyugal';
  if (regimen === 'Separación de Bienes') return 'Casado en Separacion de Bienes';
  return null;
}
const BANORTE_VIVE_EN_CASA_MAP = {
  'Propia': 'Propio',
  'Hipotecada': 'En Pago',
  'Rentada': 'En Renta',
  'Padres': 'Otro',
  'Otro Parentesco': 'Otro',
  'Otro': 'Otro',
};
function idPorNombre(catalogo, nombre) {
  if (!nombre) return '';
  const match = catalogo.find(c => c.nombre === nombre);
  return match ? match.id : '';
}

const MED_PREGUNTAS = [
  '¿Ha padecido o padece alguna enfermedad del corazón o sistema circulatorio?',
  '¿Ha padecido o padece diabetes mellitus?',
  '¿Ha padecido o padece cáncer, tumores o neoplasias?',
  '¿Ha padecido o padece enfermedades de los riñones, hígado o vías urinarias?',
  '¿Ha padecido o padece VIH/SIDA o hepatitis?',
  '¿Ha padecido o padece enfermedades del sistema nervioso, psiquiátricas o psicológicas?',
  '¿Ha padecido o padece enfermedades del aparato respiratorio?',
  '¿Se encuentra bajo tratamiento médico o tiene programada una cirugía?',
];
const MED_KEYS = ['corazon','diabetes','cancer','rinones','vih','sistema_nervioso','respiratorio','tratamiento'];

const DES_PREGUNTAS = [
  '¿Tiene un contrato de trabajo por tiempo indefinido?',
  '¿Trabaja para una empresa que tiene RFC? (no aplica para trabajadores del estado)',
];
const DES_KEYS = ['contrato','antiguedad'];

const ENTIDADES_FEDERATIVAS = [
  'Aguascalientes','Baja California','Baja California Sur','Campeche','Chiapas','Chihuahua',
  'Ciudad de México','Coahuila de Zaragoza','Colima','Durango','Guanajuato','Guerrero',
  'Hidalgo','Jalisco','Estado de México','Michoacán de Ocampo','Morelos','Nayarit',
  'Nuevo León','Oaxaca','Puebla','Querétaro','Quintana Roo','San Luis Potosí',
  'Sinaloa','Sonora','Tabasco','Tamaulipas','Tlaxcala','Veracruz de Ignacio de la Llave',
  'Yucatán','Zacatecas',
];

const st = {
  card: { backgroundColor: '#F0F0F0', padding: 24, borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', marginBottom: 20 },
  title: { fontSize: 18, fontWeight: 'bold', color: '#1a3a6e', marginBottom: 16, borderBottom: '2px solid #e11d48', paddingBottom: 8 },
  field: { marginBottom: 12 },
  label: { display: 'block', fontSize: 13, fontWeight: '600', color: '#374151', marginBottom: 6 },
  input: { width: '100%', height: '42px', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' },
  inputNum: { width: '100%', height: '42px', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' },
  readOnly: { backgroundColor: '#f3f4f6', fontWeight: 'bold' },
  moneyWrap: { position: 'relative' },
  moneySign: { position: 'absolute', left: 12, top: 11, color: '#6b7280', fontSize: 14 },
  saveBtn: { backgroundColor: '#1a3a6e', color: 'white', border: 'none', padding: '12px 24px', borderRadius: 6, fontSize: 15, fontWeight: '600', cursor: 'pointer', marginTop: 8 },
  preguntaRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0', gap: 16 },
  preguntaLabel: { flex: 1, fontSize: 13, color: '#374151' },
  preguntaSelect: { width: 120, height: '36px', padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13 },
};

const SiNoRadioBn = ({ value, onChange, name, defaultNo }) => {
  useEffect(() => {
    if (defaultNo && (value === undefined || value === null)) onChange(false);
  }, [value, defaultNo, onChange]); // eslint-disable-line react-hooks/exhaustive-deps
  const val = (value === undefined || value === null) && defaultNo ? false : value;
  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexShrink: 0 }}>
      <label style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
        <input type="radio" name={name} checked={val === true} onChange={() => onChange(true)} /> Sí
      </label>
      <label style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
        <input type="radio" name={name} checked={val === false} onChange={() => onChange(false)} /> No
      </label>
    </div>
  );
};

const BancoBanorte = ({ prospectoId, formData, setFormData }) => {
  const API = '/api';
  const { isMobile, isTablet } = useResponsive();
  const grid4 = { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', gap: 16, marginBottom: 16 };

  const [estadosCiviles, setEstadosCiviles] = useState([]);
  const [regimenes, setRegimenes] = useState([]);
  const [tiposDomicilio, setTiposDomicilio] = useState([]);
  const [tiposContrato, setTiposContrato] = useState([]);
  const [posiciones, setPosiciones] = useState([]);
  const [esquemas, setEsquemas] = useState([]);
  const [tiposCredito, setTiposCredito] = useState([]);
  const [destinosCredito, setDestinosCredito] = useState([]);
  const [plazos, setPlazos] = useState([]);

  const [bn, setBn] = useState({});
  const [banorteCargado, setBanorteCargado] = useState(false);

  useEffect(() => {
    cargarCatalogos();
  }, []);

  useEffect(() => {
    const cargarDatos = async () => {
      if (!prospectoId) { setBanorteCargado(true); return; }
      try {
        const r = await fetch(`/api/banorte/${prospectoId}`);
        if (r.ok) {
          const datos = await r.json();
          if (datos && datos.id) {
            setBn(datos);
            setFormData(prev => ({ ...prev, banorte: datos }));
          }
        }
      } catch (e) {
        console.error('Error cargando datos Banorte:', e);
      } finally {
        setBanorteCargado(true);
      }
    };
    cargarDatos();
  }, [prospectoId]);

  // Estado Civil, Régimen Conyugal y Tipo de Domicilio: se derivan del módulo
  // Titular / Coacreditado. Se recalculan cuando cambian ahí, y también una vez
  // que terminó de cargar lo guardado de Banorte, para no quedar pisados por un
  // valor anterior guardado en la base de datos.
  useEffect(() => {
    if (!banorteCargado) return;
    if (estadosCiviles.length === 0 || regimenes.length === 0 || tiposDomicilio.length === 0) return;

    const ecIdTit = idPorNombre(estadosCiviles, BANORTE_ESTADO_CIVIL_MAP[formData.titular.estado_civil] || null);
    const rcIdTit = idPorNombre(regimenes, nombreRegimenBanorte(formData.titular.estado_civil, formData.titular.regimen_matrimonio));
    const ecIdCoac = idPorNombre(estadosCiviles, BANORTE_ESTADO_CIVIL_MAP[formData.coacreditado?.estado_civil] || null);
    const rcIdCoac = idPorNombre(regimenes, nombreRegimenBanorte(formData.coacreditado?.estado_civil, formData.coacreditado?.regimen_matrimonio));
    const tdId = idPorNombre(tiposDomicilio, BANORTE_VIVE_EN_CASA_MAP[formData.titular.vive_en_casa] || null);

    setBn(prev => {
      const next = { ...prev };
      let changed = false;
      const set = (k, v) => { if (next[k] !== v) { next[k] = v; changed = true; } };
      set('estado_civil_id', ecIdTit);
      set('regimen_conyugal_id', rcIdTit);
      set('coac_estado_civil_id', ecIdCoac);
      set('coac_regimen_conyugal_id', rcIdCoac);
      set('tipo_domicilio_id', tdId);
      return changed ? next : prev;
    });
  }, [
    banorteCargado, estadosCiviles, regimenes, tiposDomicilio,
    formData.titular.estado_civil, formData.titular.regimen_matrimonio, formData.titular.vive_en_casa,
    formData.coacreditado?.estado_civil, formData.coacreditado?.regimen_matrimonio,
  ]);

  const cargarCatalogos = async () => {
    try {
      const [ec, rc, td, tc, pos, esq, tcr, dc, pl] = await Promise.all([
        fetch(`${API}/catalogos/banorte/estado_civil`).then(r => r.json()),
        fetch(`${API}/catalogos/banorte/regimen_conyugal`).then(r => r.json()),
        fetch(`${API}/catalogos/banorte/tipo_domicilio`).then(r => r.json()),
        fetch(`${API}/catalogos/banorte/tipo_contrato`).then(r => r.json()),
        fetch(`${API}/catalogos/banorte/posicion`).then(r => r.json()),
        fetch(`${API}/catalogos/banorte/esquema`).then(r => r.json()),
        fetch(`${API}/catalogos/banorte/tipo_credito`).then(r => r.json()),
        fetch(`${API}/catalogos/banorte/destino_credito`).then(r => r.json()),
        fetch(`${API}/catalogos/banorte/plazo_credito`).then(r => r.json()),
      ]);
      setEstadosCiviles(ec); setRegimenes(rc); setTiposDomicilio(td);
      setTiposContrato(tc); setPosiciones(pos); setEsquemas(esq);
      setTiposCredito(tcr); setDestinosCredito(dc); setPlazos(pl);
    } catch (e) {
      console.error('Error cargando catálogos Banorte:', e);
    }
  };

  // useCallback con deps vacías: misma referencia en todos los renders
  const upd = useCallback((campo, valor) => {
    setBn(prev => {
      const next = { ...prev, [campo]: valor };
      if (['titular_ingreso_mensual_bruto','titular_ingreso_mensual_neto','titular_otros_ingresos'].includes(campo)) {
        const b = parseFloat(String(campo === 'titular_ingreso_mensual_bruto' ? valor : next.titular_ingreso_mensual_bruto || '').replace(/,/g, '')) || 0;
        const n = parseFloat(String(campo === 'titular_ingreso_mensual_neto' ? valor : next.titular_ingreso_mensual_neto || '').replace(/,/g, '')) || 0;
        const o = parseFloat(String(campo === 'titular_otros_ingresos' ? valor : next.titular_otros_ingresos || '').replace(/,/g, '')) || 0;
        next.titular_total_ingresos = Math.round(b + n + o).toString();
      }
      if (['coac_ingreso_mensual_bruto','coac_ingreso_mensual_neto','coac_otros_ingresos'].includes(campo)) {
        const b = parseFloat(String(campo === 'coac_ingreso_mensual_bruto' ? valor : next.coac_ingreso_mensual_bruto || '').replace(/,/g, '')) || 0;
        const n = parseFloat(String(campo === 'coac_ingreso_mensual_neto' ? valor : next.coac_ingreso_mensual_neto || '').replace(/,/g, '')) || 0;
        const o = parseFloat(String(campo === 'coac_otros_ingresos' ? valor : next.coac_otros_ingresos || '').replace(/,/g, '')) || 0;
        next.coac_total_ingresos = Math.round(b + n + o).toString();
      }
      return next;
    });
  }, []);

  const guardar = async () => {
    if (!prospectoId) {
      alert('Primero guarde el prospecto antes de agregar información del banco');
      return;
    }
    if (creditoExcedeInmueble(bn.importe, bn.valor_inmueble)) { alert(MENSAJE_CREDITO_INMUEBLE); return; }
    try {
      const bnToSave = { ...bn };
      const prefijosMed = tieneCoac ? ['titular', 'coac'] : ['titular'];
      prefijosMed.forEach(prefix => {
        MED_KEYS.forEach(k => {
          const key = `${prefix}_med_${k}`;
          if (bnToSave[key] === undefined || bnToSave[key] === null) bnToSave[key] = false;
        });
      });
      const r = await fetch(`/api/banorte/${prospectoId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prospecto_id: prospectoId, ...bnToSave })
      });
      const data = await r.json();
      if (data.success) {
        setFormData(prev => ({ ...prev, banorte: bnToSave }));
        alert('✓ Información de Banorte guardada correctamente');
      } else {
        alert('Error: ' + data.error);
      }
    } catch (e) {
      alert('Error al guardar la información');
    }
  };

  const tieneCoac = !!formData.coacreditado?.nombres;
  const coacParticipaIngresos = formData.coacreditado?.participa_ingresos === true;

  // ── Helpers de render (funciones, NO componentes) ──────────────────────────
  // Al llamarse como {renderXxx()} en vez de <Xxx />, React los trata como
  // parte del mismo árbol y no desmonta/remonta los inputs al re-renderizar.

  const renderSiNo = (campo) => (
    <select
      value={bn[campo] === true ? 'true' : bn[campo] === false ? 'false' : ''}
      onChange={e => upd(campo, e.target.value === '' ? null : e.target.value === 'true')}
      style={st.input}
    >
      <option value="">-- Seleccionar --</option>
      <option value="true">Sí</option>
      <option value="false">No</option>
    </select>
  );

  const fmtMoney = (val) => {
    if (val === '' || val === null || val === undefined) return '';
    const num = Math.round(parseFloat(val));
    return isNaN(num) ? '' : num.toLocaleString('es-MX');
  };
  const parseMoney = (str) => String(str).replace(/[^0-9-]/g, '') || '';

  const renderMoney = (label, campo, width) => (
    <div style={{ ...st.field, ...(width ? { width: isMobile ? '100%' : width } : {}) }}>
      <label style={st.label}>{label}</label>
      <div style={st.moneyWrap}>
        <span style={st.moneySign}>$</span>
        <input
          type="text"
          value={fmtMoney(bn[campo])}
          onChange={e => upd(campo, parseMoney(e.target.value))}
          style={{ ...st.inputNum, paddingLeft: 24, width: '100%' }}
          placeholder="0"
        />
      </div>
    </div>
  );

  const renderMoneyReadOnly = (label, campo, width) => (
    <div style={{ ...st.field, ...(width ? { width: isMobile ? '100%' : width } : {}) }}>
      <label style={st.label}>{label}</label>
      <input
        readOnly
        value={`$${parseInt(bn[campo] || 0).toLocaleString('es-MX')}`}
        style={{ ...st.input, ...st.readOnly, width: '100%' }}
      />
    </div>
  );

  const renderTrabajo = (prefix, titulo) => (
    <div style={st.card}>
      <h3 style={st.title}>💼 {titulo}</h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32, marginBottom: 16 }}>
        <div style={{ ...st.field, width: isMobile ? '100%' : 188 }}>
          <label style={st.label}>Actividad Empresarial</label>
          {renderSiNo(`${prefix}_actividad_empresarial`)}
        </div>
        <div style={{ ...st.field, width: isMobile ? '100%' : 188 }}>
          <label style={st.label}>Tipo de Contrato</label>
          <select value={bn[`${prefix}_tipo_contrato_id`] || ''} onChange={e => upd(`${prefix}_tipo_contrato_id`, e.target.value)} style={{ ...st.input, width: '100%' }}>
            <option value="">-- Seleccionar --</option>
            {tiposContrato.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
          </select>
        </div>
        <div style={{ ...st.field, width: isMobile ? '100%' : 188 }}>
          <label style={st.label}>Posición que Ocupa</label>
          <select value={bn[`${prefix}_posicion_id`] || ''} onChange={e => upd(`${prefix}_posicion_id`, e.target.value)} style={{ ...st.input, width: '100%' }}>
            <option value="">-- Seleccionar --</option>
            {posiciones.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
          </select>
        </div>
        <div style={{ ...st.field, width: isMobile ? '100%' : 314 }}>
          <label style={st.label}>Puesto</label>
          <input value={bn[`${prefix}_puesto`] || ''} onChange={e => upd(`${prefix}_puesto`, e.target.value)} style={{ ...st.input, width: '100%' }} />
        </div>
        <div style={{ ...st.field, width: isMobile ? '100%' : 290 }}>
          <label style={st.label}>Giro o Actividad</label>
          <input value={bn[`${prefix}_giro_actividad`] || ''} onChange={e => upd(`${prefix}_giro_actividad`, e.target.value)} style={{ ...st.input, width: '100%' }} />
        </div>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32, marginBottom: 16 }}>
        {renderMoney('Ingreso Mensual Bruto', `${prefix}_ingreso_mensual_bruto`, 188)}
        {renderMoney('Ingreso Mensual Neto', `${prefix}_ingreso_mensual_neto`, 188)}
        {renderMoney('Otros Ingresos', `${prefix}_otros_ingresos`, 188)}
        <div style={{ ...st.field, width: isMobile ? '100%' : 322 }}>
          <label style={st.label}>Fuente de Otros Ingresos</label>
          <input value={bn[`${prefix}_fuente_otros_ingresos`] || ''} onChange={e => upd(`${prefix}_fuente_otros_ingresos`, e.target.value)} style={{ ...st.input, width: '100%' }} />
        </div>
        {renderMoneyReadOnly('Total (Calculado)', `${prefix}_total_ingresos`, 188)}
      </div>
    </div>
  );

  const renderMedQuestions = (prefix) => (
    <div style={{ marginTop: 12 }}>
      {MED_PREGUNTAS.map((pregunta, i) => {
        const key = `${prefix}_med_${MED_KEYS[i]}`;
        return (
          <div key={key} style={st.preguntaRow}>
            <span style={st.preguntaLabel}>{i + 1}. {pregunta}</span>
            <SiNoRadioBn name={key} value={bn[key]} onChange={v => upd(key, v)} defaultNo />
          </div>
        );
      })}
    </div>
  );

  const renderDesQuestions = (prefix) => (
    <div style={{ marginTop: 12 }}>
      {DES_PREGUNTAS.map((pregunta, i) => {
        const key = `${prefix}_des_${DES_KEYS[i]}`;
        return (
          <div key={key} style={st.preguntaRow}>
            <span style={st.preguntaLabel}>{i + 1}. {pregunta}</span>
            <SiNoRadioBn name={key} value={bn[key]} onChange={v => upd(key, v)} />
          </div>
        );
      })}
    </div>
  );

  // ── JSX principal ─────────────────────────────────────────────────────────

  return (
    <div>
      {/* INFORMACIÓN GENERAL TITULAR */}
      <div style={st.card}>
        <h3 style={st.title}>📋 Información General del Titular</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 30, marginBottom: 16 }}>
          <div style={{ ...st.field, width: isMobile ? '100%' : 149 }}>
            <label style={st.label}>¿Es Cliente Banorte?</label>
            {renderSiNo('cliente_banorte')}
          </div>
          <div style={{ ...st.field, width: isMobile ? '100%' : 186 }}>
            <label style={st.label}>Estado Civil</label>
            <input readOnly
              value={estadosCiviles.find(ec => ec.id === bn.estado_civil_id)?.nombre || ''}
              style={{ ...st.input, backgroundColor: '#f3f4f6', width: '100%' }}
              title="Se captura en la pestaña Titular" />
          </div>
          <div style={{ ...st.field, width: isMobile ? '100%' : 248 }}>
            <label style={st.label}>Régimen Conyugal</label>
            <input readOnly
              value={regimenes.find(r => r.id === bn.regimen_conyugal_id)?.nombre || ''}
              style={{ ...st.input, backgroundColor: '#f3f4f6', width: '100%' }}
              title="Se captura en la pestaña Titular" />
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 30, marginBottom: 16 }}>
          <div style={{ ...st.field, width: isMobile ? '100%' : 318 }}>
            <label style={st.label}>Nivel Académico / Profesión (Titular)</label>
            <input value={bn.nivel_academico_profesion || ''} onChange={e => upd('nivel_academico_profesion', e.target.value)} style={{ ...st.input, width: '100%' }} />
          </div>
          <div style={{ ...st.field, width: isMobile ? '100%' : 212 }}>
            <label style={st.label}>Tipo de Domicilio</label>
            <input readOnly
              value={tiposDomicilio.find(t => t.id === bn.tipo_domicilio_id)?.nombre || ''}
              style={{ ...st.input, backgroundColor: '#f3f4f6', width: '100%' }}
              title="Se captura en la pestaña Titular" />
          </div>
        </div>
      </div>

      {/* TRABAJO TITULAR */}
      {renderTrabajo('titular', 'Información del Trabajo del Titular')}

      {/* INFORMACIÓN GENERAL COACREDITADO */}
      {tieneCoac && (
        <div style={st.card}>
          <h3 style={st.title}>📋 Información General del Coacreditado</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 30, marginBottom: 16 }}>
            <div style={{ ...st.field, width: isMobile ? '100%' : 186 }}>
              <label style={st.label}>Estado Civil (Coacreditado)</label>
              <input readOnly
                value={estadosCiviles.find(ec => ec.id === bn.coac_estado_civil_id)?.nombre || ''}
                style={{ ...st.input, backgroundColor: '#f3f4f6', width: '100%' }}
                title="Se captura en la pestaña Coacreditado" />
            </div>
            <div style={{ ...st.field, width: isMobile ? '100%' : 248 }}>
              <label style={st.label}>Régimen Conyugal (Coacreditado)</label>
              <input readOnly
                value={regimenes.find(r => r.id === bn.coac_regimen_conyugal_id)?.nombre || ''}
                style={{ ...st.input, backgroundColor: '#f3f4f6', width: '100%' }}
                title="Se captura en la pestaña Coacreditado" />
            </div>
            <div style={{ ...st.field, width: isMobile ? '100%' : 318 }}>
              <label style={st.label}>Nivel Académico / Profesión (Coacreditado)</label>
              <input value={bn.coac_nivel_academico_profesion || ''} onChange={e => upd('coac_nivel_academico_profesion', e.target.value)} style={{ ...st.input, width: '100%' }} />
            </div>
          </div>
        </div>
      )}

      {/* TRABAJO COACREDITADO */}
      {tieneCoac && coacParticipaIngresos && renderTrabajo('coac', 'Información del Trabajo del Coacreditado')}

      {/* CUESTIONARIO MÉDICO TITULAR */}
      <div style={st.card}>
        <h3 style={st.title}>🏥 Cuestionario Médico del Titular</h3>
        {renderMedQuestions('titular')}
      </div>

      {/* CUESTIONARIO MÉDICO COACREDITADO */}
      {tieneCoac && (
        <div style={st.card}>
          <h3 style={st.title}>🏥 Cuestionario Médico del Coacreditado</h3>
          {renderMedQuestions('coac')}
        </div>
      )}

      {/* SEGURO DE DAÑOS */}
      <div style={st.card}>
        <h3 style={st.title}>🛡️ Seguro de Daños</h3>
        <div style={grid4}>
          <div style={st.field}>
            <label style={st.label}>Desempleo Involuntario</label>
            <select value={bn.desempleo_tipo || ''} onChange={e => upd('desempleo_tipo', e.target.value)} style={st.input}>
              <option value="">-- Seleccionar --</option>
              <option value="individual">Individual</option>
              <option value="mancomunado">Mancomunado</option>
            </select>
          </div>
          <div style={st.field}>
            <label style={st.label}>Obra</label>
            <select value={bn.obra_tipo || ''} onChange={e => upd('obra_tipo', e.target.value)} style={st.input}>
              <option value="">-- Seleccionar --</option>
              <option value="terminada">Obra Terminada</option>
              <option value="civil">Obra Civil</option>
            </select>
          </div>
          <div style={st.field}>
            <label style={st.label}>Suma Asegurada Desempleo (meses)</label>
            <input type="number" value={bn.desempleo_suma_asegurada_meses || ''} onChange={e => upd('desempleo_suma_asegurada_meses', e.target.value)} style={st.inputNum} />
          </div>
          {renderMoney('Valor según tipo de Obra', 'obra_valor')}
        </div>

        <h4 style={{ fontSize: 15, fontWeight: '600', color: '#374151', marginTop: 20, marginBottom: 4 }}>Cuestionario Desempleo del Titular</h4>
        {renderDesQuestions('titular')}

        {tieneCoac && (
          <>
            <h4 style={{ fontSize: 15, fontWeight: '600', color: '#374151', marginTop: 20, marginBottom: 4 }}>Cuestionario Desempleo del Coacreditado</h4>
            {renderDesQuestions('coac')}
          </>
        )}
      </div>

      {/* OBLIGADO SOLIDARIO (mig 110): viaja en bn.obligado_solidario dentro del mismo guardado */}
      <ObligadoSolidarioBanorte valor={bn.obligado_solidario} onChange={v => upd('obligado_solidario', v)}
        estadosCiviles={estadosCiviles} regimenes={regimenes} tiposDomicilio={tiposDomicilio} st={st} isMobile={isMobile} isTablet={isTablet} />

      {/* INFORMACIÓN DEL CRÉDITO */}
      <div style={st.card}>
        <h3 style={st.title}>🏦 Información del Crédito</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32, marginBottom: 16 }}>
          <div style={{ ...st.field, width: isMobile ? '100%' : 188 }}>
            <label style={st.label}>Oferta Vinculante</label>
            {renderSiNo('oferta_vinculante')}
          </div>
          <div style={{ ...st.field, width: isMobile ? '100%' : 330 }}>
            <label style={st.label}>Esquema</label>
            <select value={bn.esquema_id || ''} onChange={e => upd('esquema_id', e.target.value)} style={st.input}>
              <option value="">-- Seleccionar --</option>
              {esquemas.map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
            </select>
          </div>
          <div style={{ ...st.field, width: isMobile ? '100%' : 330 }}>
            <label style={st.label}>Tipo de Producto</label>
            <select value={bn.tipo_credito_id || ''} onChange={e => upd('tipo_credito_id', e.target.value)} style={st.input}>
              <option value="">-- Seleccionar --</option>
              {tiposCredito.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
            </select>
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32, marginBottom: 16 }}>
          <div style={{ ...st.field, width: isMobile ? '100%' : 375 }}>
            <label style={st.label}>Destino de Crédito</label>
            <select value={bn.destino_credito_id || ''} onChange={e => upd('destino_credito_id', e.target.value)} style={st.input}>
              <option value="">-- Seleccionar --</option>
              {destinosCredito.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
            </select>
          </div>
          <div style={{ ...st.field, width: isMobile ? '100%' : 188 }}>
            <label style={st.label}>Plazo en Años</label>
            <select value={bn.plazo_anos_id || ''} onChange={e => upd('plazo_anos_id', e.target.value)} style={st.input}>
              <option value="">-- Seleccionar --</option>
              {plazos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
            </select>
          </div>
          <div style={{ ...st.field, width: isMobile ? '100%' : 188 }}>
            <label style={st.label}>Tasa de Interés (%)</label>
            <input type="number" step="0.01" value={bn.tasa || ''} onChange={e => upd('tasa', e.target.value)} style={st.inputNum} placeholder="0.00" />
          </div>
        </div>
        <div style={grid4}>
          {renderMoney('Importe Solicitado', 'importe')}
          {renderMoney('Valor Estimado del Inmueble', 'valor_inmueble')}
          <div style={st.field}>
            <label style={st.label}>Entidad Federativa del Inmueble</label>
            <select value={bn.entidad_federativa_inmueble || ''} onChange={e => upd('entidad_federativa_inmueble', e.target.value)} style={st.input}>
              <option value="">-- Seleccionar --</option>
              {ENTIDADES_FEDERATIVAS.map(ef => <option key={ef} value={ef}>{ef}</option>)}
            </select>
          </div>
          <div style={st.field}>
            <label style={st.label}>Comisión Contratación Financiada</label>
            {renderSiNo('comision_contratacion_financiada')}
          </div>
        </div>
      </div>

      <div style={{ textAlign: 'right' }}>
        <button onClick={guardar} style={st.saveBtn}>💾 Guardar Información Banorte</button>
      </div>
    </div>
  );
};

export default BancoBanorte;
